export const PLAN_TYPES = {
  FLEXIBLE: 0,
  Y3: 1,
  Y5: 2,
  Y7: 3,
};

export const PLAN_META = [
  { id: 0, key: 'FLEXIBLE', name: 'Flexible',        tag: 'Withdraw Anytime', dailyBps: 10,  lockYears: 0 },
  { id: 1, key: 'Y3',       name: '3-Year Node',     tag: 'PinkSale Lock',    dailyBps: 50,  lockYears: 3 },
  { id: 2, key: 'Y5',       name: '5-Year Node',     tag: 'PinkSale Lock',    dailyBps: 70,  lockYears: 5 },
  { id: 3, key: 'Y7',       name: '7-Year Contributor',tag: '10X Contributor',dailyBps: 100, lockYears: 7 },
];

export const RANK_LABELS = [
  'Recruit', 'Explorer', 'Innovator', 'Pioneer', 'Trailblazer',
  'Visionary', 'Luminary', 'Titan', 'Legend', 'Icon',
];

// Rank numbers match the backend directly. R0 = Recruit (starting tier),
// R1..R9 are the earned ranks.
export const displayRank = (backendRank) => Number(backendRank || 0);
export const rankLabel = (backendRank) => RANK_LABELS[Number(backendRank || 0)] || 'Recruit';
export const rankTag = (backendRank) => `R${displayRank(backendRank)}`;

export const CEILING_LABEL = {
  20000: '2X',
  30000: '3X',
  40000: '4X',
};

export const EV_TYPE = {
  UserRegistered: 1,
  Invested: 2,
  ContributorCreated: 3,
  ROIAccrued: 4,
  LevelIncome: 5,
  RankIncome: 6,
  RankUpdated: 7,
  RewardsClaimed: 8,
  FlexibleWithdrawn: 9,
  ContributorClaimed: 10,
  ContributorSponsor: 11,
  PinkSaleLockLinked: 12,
  BucketFilled: 13,
  Blacklisted: 14,
};
